export default __webpack_public_path__ + "static/media/image-3.728da0cb.png";